import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * A leftover on the right edge: a 5-cell L3 cluster (a column of four and one beside its foot) pays 0.50 and makes two
 * L4 — the column's right foot slides into the one beside it, a candy higher up drops into the one below — and the
 * column's top L3 has no partner left: it stays, and falls with the column.
 */
export function mergeLeftover(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-leftover", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L2", "L1", "L4", "L2", "H1", "L1"],
        ["L4", "H2", "L1", "L3", "L2", "L3"],
        ["L1", "L3", "H4", "L1", "L4", "L3"],
        ["H3", "L2", "L1", "L4", "H2", "L3"],
        ["L2", "L4", "L2", "H1", "L3", "L3"],
        ["L1", "H1", "L3", "L2", "L1", "H2"],
      ],
      refill: [[], [], [], [], [], ["H3", "L3"]],
    })
    .build();
}
